import { create } from 'zustand';

/**
 * Desvio do relógio do PC em relação ao servidor (GUPM-336), medido pelo guardião da
 * sessão a cada token recém-emitido. `null` = sem sessão ou ainda não medido.
 */
interface RelogioState {
  desvioMs: number | null;
  setDesvio: (desvioMs: number | null) => void;
}

export const useRelogioStore = create<RelogioState>((set) => ({
  desvioMs: null,
  setDesvio: (desvioMs) => set({ desvioMs }),
}));
